export const ulStyle = {
  padding: '0 0 0.5rem',
};
